module.exports = __webpack_public_path__ + "img/iqnet.eb4fb27a.png";